import client from '../../base-api';

const serviceURL = '/portal/assisted-living-coaching';

const portalAssistedLivingCoachingService = {

    getFirstInterviewData(coachingId: number) {
        return client.get(`${serviceURL}/first-interview/${coachingId}`);
    },

    // First interview
    createFirstInterview(data: any) {
        return client.post(`${serviceURL}/first-interview-create`, data);
    },
    updateFirstInterview(data: any, firstInterviewId: number) {
        return client.put(`${serviceURL}/first-interview-update/${firstInterviewId}`, data);
    },
    updateFirstInterviewAsAdmin(data: any, firstInterviewId: number) {
        return client.put(`${serviceURL}/first-interview-update-as-admin/${firstInterviewId}`, data);
    },

    // Protocol
    getProtocolList(coachingId: number) {
        return client.get(`${serviceURL}/protocol-list/${coachingId}`);
    },
    getProtocol(protocolId: number) {
        return client.get(`${serviceURL}/protocol/${protocolId}`);
    },
    postProtocol(protocolData: any) {
        return client.post(`${serviceURL}/protocol-create`, protocolData);
    },
    updateProtocol(protocolData: any, protocolId: number) {
        return client.put(`${serviceURL}/protocol-update/${protocolId}`, protocolData);
    },
    updateProtocolAsAdmin(protocolData: any, protocolId: number) {
        return client.put(`${serviceURL}/protocol-update-as-admin/${protocolId}`, protocolData);
    },
    postProtocolNote(noteData: any) {
        return client.post(`${serviceURL}/protocol-note-create`, noteData);
    },
    putProtocolNote(noteData: any, protocolId: number) {
        return client.put(`${serviceURL}/protocol-note-update/${protocolId}`, noteData);
    },
    protocolDelete(protocolId: number) {
        return client.delete(`${serviceURL}/protocol-delete/${protocolId}`);
    },


    // Invitation to first appointment
    getInvitationsList(coachingId: number) {
        return client.get(`${serviceURL}/invitation-to-first-appointment-list/${coachingId}`);
    },
    getInvitation(invitationId: number) {
        return client.get(`${serviceURL}/invitation-to-first-appointment/${invitationId}`);
    },
    putInvitation(invitationData: any, invitationId: number) {
        return client.put(`${serviceURL}/invitation-to-first-appointment-update/${invitationId}`, invitationData);
    },
    postInvitation(invitationData: any) {
        return client.post(`${serviceURL}/invitation-to-first-appointment-create`, invitationData);
    },
    invitationDelete(invitationId: number) {
        return client.delete(`${serviceURL}/invitation-to-first-appointment-delete/${invitationId}`);
    },


    // Meeting data history list
    getMeetingDataHistoryList(meetingId: number) {
        return client.get(`${serviceURL}/meeting-history/${meetingId}`);
    },

    // Final interview
    getFinalInterview(coachingId: number) {
        return client.get(`${serviceURL}/final-interview/${coachingId}`);
    },
    submitFinalInterview(data: any) {
        return client.post(`${serviceURL}/final-interview`, data);
    },

    // Introductory documents
    getIntroductoryDocuments(coachingId: number) {
        return client.get(`${serviceURL}/documents/${coachingId}`);
    },
    submitIntroductoryDocuments(data: any) {
        return client.post(`${serviceURL}/documents`, data);
    },


    // Meeting list
    getMeetingList(coachingId: number, filterData: any) {
        return client.get(`${serviceURL}/meeting-list/${coachingId}`, {params: filterData});
    },

    // Digital signature
    saveDigitalSignature(data: any) {
        return client.post(`${serviceURL}/digital-signature`, data);
    },


    // Interim report
    getInterimReportList(coachingId: number) {
        return client.get(`${serviceURL}/interim-report-list/${coachingId}`);
    },
    getInterimReport(invitationId: number) {
        return client.get(`${serviceURL}/interim-report/${invitationId}`);
    },
    putInterimReport(invitationData: any, invitationId: number) {
        return client.put(`${serviceURL}/interim-report-update/${invitationId}`, invitationData);
    },
    postInterimReport(invitationData: any) {
        return client.post(`${serviceURL}/interim-report-create`, invitationData);
    },
    deleteInterimReport(invitationId: number) {
        return client.delete(`${serviceURL}/interim-report-delete/${invitationId}`);
    },


    // Invoice documents
    saveInvoiceDocuments(data: any) {
        return client.post(`${serviceURL}/invoice-documents`, data);
    },

    // Weekly and emergency plan
    getWeeklyAndEmergencyPlans(coachingId: number) {
        return client.get(`${serviceURL}/weekly-and-emergency-plans/${coachingId}`);
    },
    submitWeeklyAndEmergencyPlans(data: any) {
        return client.post(`${serviceURL}/weekly-and-emergency-plans`, data);
    },


}

export default portalAssistedLivingCoachingService;